import { convertUnit, customDate } from "../utils/common"

export const RenderPlantDetail = ({ plant, isLineCam = true }) => {
  const RenderItem = ({ src, alt, label, value }) => {
    return (
      <div style={{ display: "flex", gap: "5px", width: "100%", height: 30 }}>
        <img
          src={src}
          alt={alt}
          style={{
            width: 12,
            height: 12,
            pointerEvents: "none",
            marginTop: 3,
          }}
        />
        <div
          style={{
            fontFamily: "noto-sans",
            fontWeight: 300,
            fontSize: "10px",
            lineHeight: "120%",
            letterSpacing: "2%",
            verticalAlign: "middle",
            color: "#1F1F21",
            display: "flex",
            flexDirection: "column",
            gap: "2px",
          }}>
          <span>{label}</span>
          <span style={{ fontWeight: 500 }}>{value}</span>
        </div>
      </div>
    )
  }

  return (
    <>
      <div style={{ display: "flex", gap: "8px", marginBottom: 6, marginLeft: "-4px", alignItems: "center", height: 20 }}>
        <img
          src={`${process.env.PUBLIC_URL}/icons/location.svg`}
          alt="location"
          style={{
            width: 16,
            height: 16,
            pointerEvents: "none",
          }}
        />
        <h4
          style={{
            fontFamily: "noto-sans",
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "140%",
            letterSpacing: "0%",
            verticalAlign: "middle",
            color: "#1F1F21",
            ...(isLineCam ? { overflow: "hidden", display: "-webkit-box", WebkitBoxOrient: "vertical", WebkitLineClamp: 1 } : {}),
          }}>
          {plant.siteName}
        </h4>
      </div>
      <p
        style={{
          fontFamily: "noto-sans",
          margin: "0px 0px 8px",
          fontWeight: 400,
          fontSize: "12px",
          lineHeight: "140%",
          letterSpacing: "0%",
          verticalAlign: "middle",
          color: "#1F1F21",
          ...(isLineCam ? { overflow: "hidden", display: "-webkit-box", WebkitBoxOrient: "vertical", WebkitLineClamp: 1 } : {}),
        }}>
        {plant.address}
      </p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "6px 12px", marginLeft: "-2px", width: "100%" }}>
        <RenderItem
          src={`${process.env.PUBLIC_URL}/icons/lightning.svg`}
          alt="lightning"
          label="Generation Energy"
          value={convertUnit(plant?.lifetimeGenerated || 0, "kWh")}
        />
        <RenderItem
          src={`${process.env.PUBLIC_URL}/icons/battery_full.svg`}
          alt="battery_full"
          label="Capacity"
          value={convertUnit(plant?.siteCapacity, "kWp")}
        />
        <RenderItem
          src={`${process.env.PUBLIC_URL}/icons/calendar.svg`}
          alt="calendar"
          label="Comercial Operation Date"
          value={plant?.COD ? customDate(plant?.COD || "", "YYYYMMDD", "DD MMM YYYY") : "--"}
        />
        <RenderItem
          src={`${process.env.PUBLIC_URL}/icons/sun.svg`}
          alt="sun"
          label="Operational Days"
          value={plant?.runningDay || "--"}
        />
      </div>
    </>
  )
}

export const generatePlantInfoWindowHTML = (plant) => {
  return `
    <div style="font-family: noto-sans, sans-serif; color: #1F1F21; font-size: 12px; max-width: 300px;">
      <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px;">
        <img src="${`${process.env.PUBLIC_URL}/icons/location.svg`}" width="12" height="12" />
        <h4 style="margin: 0; font-size: 14px; font-weight: 500;">${plant.siteName}</h4>
      </div>
      <p style="margin: 0 0 8px;">${plant.address}</p>
      <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 6px;">
        ${[
          {
            icon: `${process.env.PUBLIC_URL}/icons/lightning.svg`,
            label: "Generation Energy",
            value: convertUnit(plant?.lifetimeGenerated || 0, "kWh"),
          },
          {
            icon: `${process.env.PUBLIC_URL}/icons/battery_full.svg`,
            label: "Capacity",
            value: convertUnit(plant?.siteCapacity || 0, "kWp"),
          },
          {
            icon: `${process.env.PUBLIC_URL}/icons/calendar.svg`,
            label: "Comercial Operation Date",
            value: plant?.COD ? customDate(plant?.COD || "", "YYYYMMDD", "DD MMM YYYY") : "--",
          },
          {
            icon: `${process.env.PUBLIC_URL}/icons/sun.svg`,
            label: "Operational Days",
            value: plant?.runningDay || "--",
          },
        ]
          .map(
            (item) => `
            <div style="display: flex; gap: 5px; height: 30px;">
              <img src="${item.icon}" width="12" height="12" style="margin-top: 3px;" />
              <div style="display: flex; flex-direction: column; font-size: 10px;">
                <span>${item.label}</span>
                <span style="font-weight: 500;">${item.value}</span>
              </div>
            </div>
          `,
          )
          .join("")}
      </div>
    </div>
  `
}
